import Translate from '@web/components/Translate/Translate';
import Icon from 'carbon-react/lib/components/icon';
import IconButton from 'carbon-react/lib/components/icon-button';
import Preview from 'carbon-react/lib/components/preview';
import styled from 'styled-components';

const ChevronIcon = styled(Icon)<{ open: boolean }>`
  transition: transform 0.3s ease-in-out;
  transform: ${({ open }) => (open ? 'rotate(0deg)' : 'rotate(-90deg)')};
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.palette.slateTint(80)};
  padding: ${({ theme }) => theme.space[3]};
`;

const Title = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
  font-size: 24px;
  font-weight: 700;
`;

const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[4]};
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 400px;
  gap: ${({ theme }) => theme.space[1]};
`;
const FieldLabel = styled.div`
  color: ${({ theme }) => theme.palette.blackOpacity(0.9)};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;
const FieldContent = styled.div`
  display: flex;
  align-items: center;

  > * {
    flex: 1;
  }
`;

export const PreviewTimesheetInformation = () => {
  return (
    <Root>
      <Title>
        <IconButton aria-label="icon-button" onClick={() => undefined}>
          <ChevronIcon fontSize="medium" open={true} type="chevron_down" />
        </IconButton>
        <Translate scope="timesheet.Information" />
      </Title>
      <Container>
        <Field>
          <FieldLabel>
            <Preview height="17px" width="150px" />
          </FieldLabel>
          <FieldContent>
            <Preview height="40px" width="400px" />
          </FieldContent>
        </Field>
        <Field>
          <FieldLabel>
            <Preview height="17px" width="150px" />
          </FieldLabel>
          <FieldContent>
            <Preview height="40px" width="400px" />
          </FieldContent>
        </Field>
        <Field>
          <FieldLabel>
            <Preview height="17px" width="150px" />
          </FieldLabel>
          <FieldContent>
            <Preview height="40px" width="400px" />
          </FieldContent>
        </Field>
      </Container>
    </Root>
  );
};
